import api from "@/api";
import { downloadResponseAsFile } from "@/shared/helpers/downloadHelper";
import { createUploadFormData, createUploadOptions } from "@/shared/helpers/uploadHelper";

const url = "/appeals";
const submitUrl="packet/getSubmitPacket";
const submitHistoryUrl="packet/getSubmitPacketHistory";
const subpart = "files";
const deleteSubmitPacket = "deleteSubmitPacket";
const appealOtherDocumentUrl="packet/getAppealOtherDocument";

export async function list(id, params) {
	const response = await api.get(`${url}/${id}/${subpart}`, params);
	

	return response.data.data.sort((a, b) => b.last_modified - a.last_modified);
}
export async function listSubmit(id, params) {
	const response = await api.get(`${url}/${id}/${submitUrl}/?id=${id}`, params);
	return response.data.data;
}

export async function listSubmitHistory(id, params) {
	const response = await api.get(`${url}/${id}/${submitHistoryUrl}`, params);
	return response.data.data;
}
export async function listAppealOtherDocument(id, params) {
	const response = await api.get(`${url}/${id}/${appealOtherDocumentUrl}/?id=${id}`, params);
	return response.data.data;
}
export async function download(id, params) {
	const response = await api.get(`${url}/${id}/${subpart}/download?name=${params.name}`, {
		responseType: "arraybuffer",
	});
	downloadResponseAsFile({
		contents: response.data,
		name: params.name,
	});
}
export async function downloadSubmitPacket(id, params) {
	const response = await api.get(`${url}/${id}/${subpart}/downloadSubmitPacket?name=${params.name}`, {
		responseType: "arraybuffer",
	});
	downloadResponseAsFile({
		contents: response.data,
		name: params.name,
	});
}
export async function downloadAppealOtherDocumentUrl(id, params) {
	const response = await api.get(`${url}/${id}/${subpart}/downloadAppealOtherDocument?name=${params.name}`, {
		responseType: "arraybuffer",
	});
	downloadResponseAsFile({
		contents: response.data,
		name: params.name,
	});
}


export function previewUrl(id, params) {
	const baseUrl = api.getBaseUrl();
	const token = api.getApiToken();

	return `${baseUrl || params.baseUrl}${url}/${id}/${subpart}/preview/${params.name}?token=${token || params.token}`;
}

export function previewSubmitPacketUrl(id, params) {
	const baseUrl = api.getBaseUrl();
	const token = api.getApiToken();

	return `${baseUrl || params.baseUrl}${url}/${id}/${subpart}/previewSubmitPacket/${params.name}?token=${token || params.token}`;
}
export function previewAppealOtherDocumentUrl(id, params) {
	const baseUrl = api.getBaseUrl();
	const token = api.getApiToken();

	return `${baseUrl || params.baseUrl}${url}/${id}/${subpart}/previewAppealOtherDocument/${params.name}?token=${token || params.token}`;
}
export async function upload(params, callback) {
	const data = createUploadFormData(params.files);
	const options = createUploadOptions((percentage) => callback(percentage));
	const response = await api.post(`${url}/${params.path || params.id}/${subpart}`, data, options);
	return response.data;
}

export async function destroy(id, params) {
	const response = await api.delete(`${url}/${id}/${subpart}?name=${params.name}`);
	return response.data;
}
export async function deleteAppealOtherDocumentUrl(id, params) {
	const response = await api.delete(`${url}/${id}/${subpart}/?name=${params.name}&id=${params.id}&module=${params.module}`);
	return response.data;
}
export async function destroySubmitPacket(id, params) {
	const response = await api.delete(`${url}/${id}/${subpart}/?name=${params.name}&&id=${params.id}`);
	return response.data;
}

export async function rename(id, params) {
	const response = await api.post(`${url}/${id}/${subpart}/rename`, {
		filename: params.filename,
		newname: params.newName,
	});
	return response.data;
}
export async function renameAppealOtherDocument(id, params) {
	const response = await api.post(`${url}/${id}/${subpart}/renameAppealOtherDocument/?id=${params.id}`, {
		filename: params.filename,
		newname: params.newName,
	});
	return response.data;
}

export async function renameSubmitPacket(id, params) {
	const response = await api.post(`${url}/${id}/${subpart}/renameSubmitPacket/?id=${params.id}`, {
		filename: params.filename,
		newname: params.newName,
	});
	return response.data;
}

export async function merge(id, params) {
	const response = await api.post(`${url}/${id}/${subpart}/merge`, params);
	return response.data;
}

export async function zip(id, params) {
	const response = await api.post(`${url}/${id}/${subpart}/zip`, params);
	return response.data;
}
export async function uploadAppealOtherDoc(params, callback) {
	const data = createUploadFormData(params.files);
	data.append("appeal_id", params.path);
	const options = createUploadOptions((percentage) => callback(percentage));
	const response = await api.post(`${url}/${params.path || params.id}/${subpart}/addAppealOtherDocument`, data, options);
	return response.data;
}
